<div class="form-horizontal" [formGroup]="flatInstructions">
  <div class="form-group">
    <label class="control-label col-sm-2">Direct Seed To Pots?</label>
    <span class="col-sm-10">
        <ui-switch formControlName="directSeedToPots" checkedLabel="Yes" uncheckedLabel="No"></ui-switch>
    </span> 
  </div>

  <div *ngIf="!directSeedToPots.value">
    <div class="form-group" [class.has-error]="flatType.invalid">
      <label class="control-label col-sm-2">Flat Type</label>
      <span class="col-sm-10">
        <select formControlName="flatType" class="form-control">
          <option [ngValue]="null"></option>
          <option *ngFor="let option of options.flatTypes" [ngValue]="option.id">{{ option.display }}</option>
        </select>
      </span>
    </div>

    <div class="form-group" [class.has-error]="substrate.invalid">
      <label class="control-label col-sm-2">Substrate</label>
      <span class="col-sm-10">
        <select formControlName="substrate" class="form-control">
          <option [ngValue]="null"></option>
          <option *ngFor="let option of options.substrates" [ngValue]="option.id">{{ option.display }}</option>
        </select>
      </span>
    </div>

    <div class="form-group" [class.has-error]="irrigation.invalid">
      <label class="control-label col-sm-2">Irrigation</label>
      <span class="col-sm-10">
        <select formControlName="irrigation" class="form-control">
          <option [ngValue]="null"></option>
          <option *ngFor="let option of options.irrigations" [ngValue]="option.id">{{ option.display }}</option>
          </select>
      </span>
    </div>

    <div class="form-group" [class.has-error]="fertigation.invalid">
      <label class="control-label col-sm-2">Fertigation</label>
      <span class="col-sm-10">
        <select formControlName="fertigation" class="form-control">
          <option [ngValue]="null"></option>
          <option *ngFor="let option of options.fertigations" [ngValue]="option.id">{{ option.display }}</option>
        </select>
      </span>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-design/flat-instructions/flat-instructions-form/flat-instructions-form.component.html